export default __webpack_public_path__ + "static/media/llanta_1.fe3c2e54.svg";